import { translateFormatter } from '@/core/localization/translate';
export const discoverTheBrandStore = translateFormatter<{
  brandName: string;
}>([{
  "type": 0,
  "value": "Discover the "
}, {
  "type": 1,
  "value": "brandName"
}, {
  "type": 0,
  "value": " store"
}], undefined, undefined, "en");